import styled from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import {
  compose,
  flexbox,
  layout,
  space,
  position,
  FlexboxProps,
  SpaceProps,
  LayoutProps,
  PositionProps,
} from 'styled-system';

export type FlexProps = FlexboxProps & LayoutProps & SpaceProps & PositionProps;

// alignItems is a valid prop in the typing, but we don't want to pass it to the DOM element
// because it's not a valid prop for the DOM element
const FlexWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => isPropValid(prop),
})<FlexProps>`
  display: flex;
  align-items: ${({ alignItems }) => alignItems || 'stretch'};
`;

const Flex = styled(FlexWrapper)<FlexProps>(
  compose(layout, flexbox, space, position)
);

export default Flex;
